import { render, staticRenderFns } from "./ChatImageModal.vue?vue&type=template&id=ccad9f88&"
import script from "./ChatImageModal.vue?vue&type=script&lang=js&"
export * from "./ChatImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports